<script setup lang="ts">
import DriverModeInfoModal from "@/components/AccountParts/DriverModeInfoModal.vue";
import RoleAssignInfoModal from '@/components/AccountParts/RoleAssignInfoModal.vue';
import { computed } from 'vue'

type modalContentType = {
  email: string,
  password: string,
  name: string[]
}

const emit = defineEmits(['update:modelValue']);
const props = withDefaults(
  defineProps<{
    modelValue: boolean
    isDriverMode: boolean
    accountId: string | null
    modalContent: modalContentType
    update: (bool: boolean) => void
    isLoading: boolean
    roleAssignAuthority: boolean
  }>(),
  {
    isDriverMode: false,
    isLoading: false
  }
)

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})
</script>
<template>
  <DriverModeInfoModal
    v-if="props.isDriverMode"
    v-model="modelValue"
    :accountId="props.accountId"
    :email="props.modalContent.email"
    :password="props.modalContent.password"
    :name="props.modalContent.name"
    :isLoading="props.isLoading"
    :isDriverMode="props.isDriverMode"
    :roleAssignAuthority="props.roleAssignAuthority"
    :update="props.update"
  />
  <RoleAssignInfoModal
    v-else
    v-model="modelValue"
    :roleAssignAuthority="props.roleAssignAuthority"
  />
</template>
